import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { PageNotFoundComponent } from './pages/errors/page-not-found/page-not-found.component';
import { SomethingWentWrongComponent } from './pages/errors/something-went-wrong/something-went-wrong.component';
import { TooManyRequestsComponent } from './pages/errors/too-many-requests/too-many-requests.component';

const routes: Routes = [
  { path: 'chat', loadChildren: () => import('./pages/chatbot/chat.module').then(m => m.ChatBotModule), canActivate: [AuthGuard] },
  { path: 'update-payment', loadChildren: () => import('./pages/card-renewal/card-renewal.module').then(m => m.CardRenewalModule),  canActivate: [AuthGuard] },
  { path: 'before-you-start', loadChildren: () => import('./pages/before-you-start/before-you-start.module').then(m => m.BeforeYouStartModule), canActivate: [AuthGuard] },
  { path: 'wellbeing-hub', loadChildren: () => import('./pages/wellbeing-hub/wellbeing-hub.module').then(m => m.WellbeingHubModule),  canActivate: [AuthGuard] },
  //Unauthorised pages
  { path: 'usl', redirectTo: 'secureLink/identity' },
  { path: 'secureLink', loadChildren: () => import('./pages/secure-link/secure-link.module').then(m => m.SecureLinkModule), },
  { path: '500', component: SomethingWentWrongComponent },
  { path: '404', component: PageNotFoundComponent },
  { path: '429', component: TooManyRequestsComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
